import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  icon?: string;
  title?: string;
  description?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductBenefitsItem',
  props: {
    icon: { default: '' },
    title: { default: '' },
    description: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true,CdnImg }
}

})